<template lang="pug">
  div(:id="`container-${this._uid}`" :class="`${this.payload.fields.templateId} ${this.classes}`")
    div(v-if="this.link === ''")
      image-block(:payload="this.image")
      h4.title {{this.title}}
      vue-markdown.desc(:source='this.desc')
      div#divider or
    div(v-if="this.link !== '' && this.title && this.payload.fields.linkLabel")
      h4.title {{this.title}}
    parallax(:animationTarget="['position']" :delay="-70")
      router-link.button(v-if="!this.isOutbound && this.link !== ''" v-on:click.native="register" :to="{ name: 'pageScene', params: { page: this.link} }") {{this.payload.fields.linkLabel || this.payload.fields.title}}
        //- vue-markdown.desc(:source='this.desc')
      a.button(v-if="this.isOutbound && this.link !== ''" :href="this.link" v-on:click.native="register") {{this.payload.fields.linkLabel || this.payload.fields.title}}
        //- vue-markdown.desc(:source='this.desc')
</template>

<script>
import Vue from 'vue'
import sectionBase from '@/components/sections/_sectionBase.js'

// component instance
var Banner = Vue.component('banner', {
  name: 'Banner',
  mixins: [sectionBase],
  props: [],
  data: function () {
    return {
    }
  },
  watch: {
  },
  methods: {
    register (e) {
      // console.log('banner click')
      this.$gtm.trackEvent({
        event: 'interaction', // Event type [default = 'interaction'] (Optional)
        category: 'Banner.navigate',
        action: 'click',
        label: e.target.textContent,
        value: 1
        // noninteraction: false // Optional
      })
    }
  },
  computed: {
    isOutbound () {
      if (this.link === '' || !this.link) return false

      return this.link.match('http') !== null
    }
  },
  created () {
  },
  mounted () {
  },
  beforeCreate () {
  },
  beforeUpdate () {
  },
  beforeDestroy () {
  }
})

// export component
export default Banner
</script>

<style lang="scss" scoped>
  .title{ display: inline; margin-right: #{measure(xxs) / 2}}
  .desc, .desc p{
    display: inline;
  }
  .page-title{

  }
  #divider{
    font-style: italic;
    margin: #{measure(s) + .5} 0;
  }

  // NOTE: this setup repositions the whole banner-add-contact ordeal into the desired position...
  // also affects the below divider
  .image{
    transform: scale(.3);
    transform-origin: bottom center;
    margin-bottom: measure(xxs);
    margin-top: -#{measure(m)};
  }
</style>



// WEBPACK FOOTER //
// src/components/sections/banner.vue